(function () {
    'use strict';

    angular
        .module('app.ics')
        .controller('InterceptionController', Interception);


    Interception.$inject = ['$scope', '$window', 'IcsSettings' ];

    function Interception($scope, $window, IcsSettings) {
        var vm = this;

        var clipboard = new Clipboard('.copy-snippet');

        vm.dataValid = false;
        vm.saving = false;

        vm.targetImageWidth = 250;
        vm.targetImageHeight = 60;
        vm.bgColor = '';

        vm.originalSettings = {};

        vm.settings = {
            primaryColor: "",
            invitationTitle: "",
            invitationText: "",
            acceptButtonText: "",
            rejectButtonText: "",
            logoImage: ""
        };

        vm.colorPattern = "#(?:[0-9a-fA-F]{3}){1,2}";

        vm.codeSnippet = "";

        vm.step = {
            steps: ['branding', 'settings', 'codesnippet'],
            current: 0,
            hasPrev: function () {
                return this.current != 0;
            },
            hasNext: function () {
                return this.current != this.steps.length - 1;
            },
            prev: function () {
                this.current--;
                $window.location.hash = this.steps[this.current];
            },
            next: function () {
                this.current++;
                $window.location.hash = this.steps[this.current];
            },
            goTo: function (num) {
                $window.location.hash = this.steps[num];
            },
            init: function () {
                if ($window.location.hash){
                    var currentStepName = _.find(this.steps, function(item) { return $window.location.hash.indexOf(item) >= 0; });
                    this.current = _.indexOf(this.steps, currentStepName);
                    if (this.current == -1) {
                        this.goTo(0);
                    }
                }

                return this;
            }
        }.init(); // initialize the step

        vm.checkIfStringValid = function(value) {
            return value != null && value != undefined && value.length > 0;
        }

        $scope.$watch(function () {
            return vm.settings;
        }, function (newValue) {
            var colorReg = new RegExp(vm.colorPattern);

            if (colorReg.test(newValue.primaryColor)){
                vm.bgColor = newValue.primaryColor;
            }

            vm.dataValid = colorReg.test(newValue.primaryColor)
                && vm.checkIfStringValid(newValue.invitationText)
                && vm.checkIfStringValid(newValue.invitationTitle)
                && vm.checkIfStringValid(newValue.acceptButtonText)
                && vm.checkIfStringValid(newValue.rejectButtonText)
                && vm.checkIfStringValid(newValue.logoImage);
        }, true);

        var settings = IcsSettings.get({id : window.ICS_CONFIG.accountId}, function(data){
            if (data.hasSettings === true){
                for(var p in vm.settings){
                    if (data.settings.hasOwnProperty(p)){
                        vm.settings[p] = data.settings[p];

                        if (p == 'primaryColor'){
                            vm.bgColor = data.settings[p];
                        }
                    }
                }
            }

            vm.codeSnippet = data.snippet;
        });

        // support for backward and forward button
        $(window).on('hashchange', function () {
            vm.step.init();
            $scope.$digest();
        });

        vm.saveSettings = function(){
            vm.saving = true;
            IcsSettings.update({id : window.ICS_CONFIG.accountId}, vm.settings, function(response){
                window.location.assign("/ics");
            });
        };
    }
})();